module.exports = __webpack_public_path__ + "img/elo.81fd4939.png";